import { render, staticRenderFns } from "./OperationLogTable.vue?vue&type=template&id=1f967b61&scoped=true&"
import script from "./OperationLogTable.vue?vue&type=script&lang=ts&"
export * from "./OperationLogTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f967b61",
  null
  
)

export default component.exports